"use strict";

var _objectSpread = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var cov_2p5bz70alf = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/tree-blob/withBlob.js";
  var hash = "ea108fb695127bc3e182d5ca57a3c51660b8f5c3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/tree-blob/withBlob.js",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 60,
          column: 3
        }
      },
      "1": {
        start: {
          line: 12,
          column: 29
        },
        end: {
          line: 12,
          column: 43
        }
      },
      "2": {
        start: {
          line: 14,
          column: 20
        },
        end: {
          line: 14,
          column: 35
        }
      },
      "3": {
        start: {
          line: 14,
          column: 27
        },
        end: {
          line: 14,
          column: 34
        }
      },
      "4": {
        start: {
          line: 16,
          column: 21
        },
        end: {
          line: 16,
          column: 23
        }
      },
      "5": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 20,
          column: 5
        }
      },
      "6": {
        start: {
          line: 18,
          column: 35
        },
        end: {
          line: 18,
          column: 51
        }
      },
      "7": {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 19,
          column: 39
        }
      },
      "8": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 23,
          column: 5
        }
      },
      "9": {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 22,
          column: 49
        }
      },
      "10": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 26,
          column: 5
        }
      },
      "11": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 54
        }
      },
      "12": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 18
        }
      },
      "13": {
        start: {
          line: 33,
          column: 23
        },
        end: {
          line: 37,
          column: 5
        }
      },
      "14": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 34,
          column: 57
        }
      },
      "15": {
        start: {
          line: 34,
          column: 18
        },
        end: {
          line: 34,
          column: 57
        }
      },
      "16": {
        start: {
          line: 34,
          column: 41
        },
        end: {
          line: 34,
          column: 54
        }
      },
      "17": {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 36,
          column: 27
        }
      },
      "18": {
        start: {
          line: 35,
          column: 18
        },
        end: {
          line: 35,
          column: 33
        }
      },
      "19": {
        start: {
          line: 36,
          column: 11
        },
        end: {
          line: 36,
          column: 27
        }
      },
      "20": {
        start: {
          line: 38,
          column: 20
        },
        end: {
          line: 38,
          column: 43
        }
      },
      "21": {
        start: {
          line: 40,
          column: 20
        },
        end: {
          line: 40,
          column: 27
        }
      },
      "22": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 52,
          column: 5
        }
      },
      "23": {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 51,
          column: 8
        }
      },
      "24": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 57,
          column: 5
        }
      },
      "25": {
        start: {
          line: 55,
          column: 25
        },
        end: {
          line: 55,
          column: 57
        }
      },
      "26": {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 56,
          column: 80
        }
      },
      "27": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 21
        }
      },
      "28": {
        start: {
          line: 63,
          column: 0
        },
        end: {
          line: 91,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "withBlob",
        decl: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 6,
            column: 24
          }
        },
        loc: {
          start: {
            line: 6,
            column: 36
          },
          end: {
            line: 61,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "BlobComponent",
        decl: {
          start: {
            line: 7,
            column: 18
          },
          end: {
            line: 7,
            column: 31
          }
        },
        loc: {
          start: {
            line: 11,
            column: 5
          },
          end: {
            line: 60,
            column: 3
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 14,
            column: 20
          },
          end: {
            line: 14,
            column: 21
          }
        },
        loc: {
          start: {
            line: 14,
            column: 27
          },
          end: {
            line: 14,
            column: 34
          }
        },
        line: 14
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 33,
            column: 23
          },
          end: {
            line: 33,
            column: 24
          }
        },
        loc: {
          start: {
            line: 33,
            column: 35
          },
          end: {
            line: 37,
            column: 5
          }
        },
        line: 33
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 34,
            column: 33
          },
          end: {
            line: 34,
            column: 34
          }
        },
        loc: {
          start: {
            line: 34,
            column: 39
          },
          end: {
            line: 34,
            column: 56
          }
        },
        line: 34
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 20,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 20,
            column: 5
          }
        }, {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 20,
            column: 5
          }
        }],
        line: 17
      },
      "1": {
        loc: {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        }, {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        }],
        line: 21
      },
      "2": {
        loc: {
          start: {
            line: 21,
            column: 8
          },
          end: {
            line: 21,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 8
          },
          end: {
            line: 21,
            column: 24
          }
        }, {
          start: {
            line: 21,
            column: 28
          },
          end: {
            line: 21,
            column: 43
          }
        }],
        line: 21
      },
      "3": {
        loc: {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        }, {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        }],
        line: 24
      },
      "4": {
        loc: {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 34,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 34,
            column: 57
          }
        }, {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 34,
            column: 57
          }
        }],
        line: 34
      },
      "5": {
        loc: {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 36,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 36,
            column: 27
          }
        }, {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 36,
            column: 27
          }
        }],
        line: 35
      },
      "6": {
        loc: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }, {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }],
        line: 41
      },
      "7": {
        loc: {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 18
          }
        }, {
          start: {
            line: 41,
            column: 23
          },
          end: {
            line: 41,
            column: 27
          }
        }, {
          start: {
            line: 41,
            column: 31
          },
          end: {
            line: 41,
            column: 34
          }
        }],
        line: 41
      },
      "8": {
        loc: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        }, {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        }],
        line: 54
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "ea108fb695127bc3e182d5ca57a3c51660b8f5c3"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withBlob = withBlob;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tree = require("./Tree");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function withBlob(Component) {
  cov_2p5bz70alf.f[0]++;
  cov_2p5bz70alf.s[0]++;
  return function BlobComponent(_ref) {
    var blob = _ref.blob,
        onBlob = _ref.onBlob,
        props = _objectWithoutProperties(_ref, ["blob", "onBlob"]);

    cov_2p5bz70alf.f[1]++;

    var _ref2 = (cov_2p5bz70alf.s[1]++, (0, _react.useState)(blob)),
        _ref3 = _slicedToArray(_ref2, 2),
        _blob = _ref3[0],
        setBlob = _ref3[1];

    cov_2p5bz70alf.s[2]++;

    var hasBlob = function hasBlob() {
      cov_2p5bz70alf.f[2]++;
      cov_2p5bz70alf.s[3]++;
      return !!_blob;
    };

    var blobConfig = (cov_2p5bz70alf.s[4]++, {});
    cov_2p5bz70alf.s[5]++;

    if (props.blobConfig) {
      cov_2p5bz70alf.b[0][0]++;

      var _ref4 = (cov_2p5bz70alf.s[6]++, props.blobConfig),
          _url = _ref4.url,
          _tree = _ref4.tree,
          _config2 = _objectWithoutProperties(_ref4, ["url", "tree"]);

      cov_2p5bz70alf.s[7]++;
      blobConfig = {
        url: _url,
        tree: _tree,
        config: _config2
      };
    } else {
      cov_2p5bz70alf.b[0][1]++;
    }

    cov_2p5bz70alf.s[8]++;

    if ((cov_2p5bz70alf.b[2][0]++, props.repository) && (cov_2p5bz70alf.b[2][1]++, !blobConfig.url)) {
      cov_2p5bz70alf.b[1][0]++;
      cov_2p5bz70alf.s[9]++;
      blobConfig.url = props.repository.tree_url;
    } else {
      cov_2p5bz70alf.b[1][1]++;
    }

    cov_2p5bz70alf.s[10]++;

    if (props.authentication) {
      cov_2p5bz70alf.b[3][0]++;
      cov_2p5bz70alf.s[11]++;
      blobConfig.config = props.authentication.config;
    } else {
      cov_2p5bz70alf.b[3][1]++;
    }

    var _ref5 = (cov_2p5bz70alf.s[12]++, blobConfig),
        url = _ref5.url,
        tree = _ref5.tree,
        config = _ref5.config;

    cov_2p5bz70alf.s[13]++;

    var updateBlob = function updateBlob(__blob) {
      cov_2p5bz70alf.f[3]++;
      cov_2p5bz70alf.s[14]++;

      if (__blob) {
        cov_2p5bz70alf.b[4][0]++;
        cov_2p5bz70alf.s[15]++;

        __blob.close = function () {
          cov_2p5bz70alf.f[4]++;
          cov_2p5bz70alf.s[16]++;
          updateBlob();
        };
      } else {
        cov_2p5bz70alf.b[4][1]++;
      }

      cov_2p5bz70alf.s[17]++;

      if (onBlob) {
        cov_2p5bz70alf.b[5][0]++;
        cov_2p5bz70alf.s[18]++;
        onBlob(__blob);
      } else {
        cov_2p5bz70alf.b[5][1]++;
        cov_2p5bz70alf.s[19]++;
        setBlob(__blob);
      }
    };

    var _config = (cov_2p5bz70alf.s[20]++, _objectSpread({}, config, {
      updateBlob: updateBlob
    }));

    var component = (cov_2p5bz70alf.s[21]++, _react.default.createElement("div", null));
    cov_2p5bz70alf.s[22]++;

    if ((cov_2p5bz70alf.b[7][0]++, !hasBlob()) && ((cov_2p5bz70alf.b[7][1]++, tree) || (cov_2p5bz70alf.b[7][2]++, url))) {
      cov_2p5bz70alf.b[6][0]++;
      cov_2p5bz70alf.s[23]++;
      component = _react.default.createElement(_Tree.Tree, _extends({
        tree: tree,
        url: url,
        config: _config,
        selected: true,
        onBlob: updateBlob
      }, blobConfig));
    } else {
      cov_2p5bz70alf.b[6][1]++;
    }

    cov_2p5bz70alf.s[24]++;

    if (hasBlob()) {
      cov_2p5bz70alf.b[8][0]++;
      var fileConfig = (cov_2p5bz70alf.s[25]++, _objectSpread({}, config, {}, props.fileConfig));
      cov_2p5bz70alf.s[26]++;
      component = _react.default.createElement(Component, _extends({}, props, {
        blob: _blob,
        fileConfig: fileConfig
      }));
    } else {
      cov_2p5bz70alf.b[8][1]++;
    }

    cov_2p5bz70alf.s[27]++;
    return component;
  };
}

cov_2p5bz70alf.s[28]++;
withBlob.propTypes = {
  /** Pass a previously returned blob object to bypass the selection. */
  blob: _propTypes.default.shape({
    /** The filepath in the Git Tree Blob Object */
    path: _propTypes.default.string.isRequired,

    /** The url in the Git Tree Blob Object */
    url: _propTypes.default.string,

    /** The content size of the Git Tree Blob Object */
    size: _propTypes.default.number
  }),

  /** Function to propogate when the Blob is selected. */
  onBlob: _propTypes.default.func,

  /** Configuration to pass through to the Search/Repositories component. */
  blobConfig: _propTypes.default.shape({
    /** An array of paths from the Gitea file tree api. */
    tree: _propTypes.default.arrayOf(_propTypes.default.shape({
      path: _propTypes.default.string.isRequired,
      type: _propTypes.default.oneOf(['tree', 'blob']).isRequired
    })),

    /** The Url to fetch the listing if listing is not provided. */
    url: _propTypes.default.string,

    /** The depth of the path in the tree sets the inset of the component. */
    depth: _propTypes.default.number
  }).isRequired,

  /** Repository tree_url can be used in place of blobConfig */
  repository: _propTypes.default.shape({
    tree_url: _propTypes.default.string.isRequired
  })
};